import Base from 'base.service';

export default class Dashboard extends Base {
  constructor ($http) {
    'ngInject';

    super($http);
  }

  getTasks() {
    return this.getList('/dashboard/tasks.json');
  }

  getNotifications(params) {
    return this.getList(`/dashboard/notifications.json?filter=${params.filter}&page=${params.page}`);
  }

  getStatistics() {
    return this.$http.get(this.pingstaApiUrl + '/dashboard/statistics.json').then(response => response.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/util/dashboard.service.js